// ── Shared customer/distributor profile store ──
// Syncs profile data between customer portal and admin control panel.
// When customer edits their profile → admin sees it.
// When admin edits an account → customer portal sees it.

const LS_KEY = "mpcare_shared_customer_profiles";

function load() {
  try { const raw = localStorage.getItem(LS_KEY); if (raw) return JSON.parse(raw); } catch (e) {}
  return {};
}

function save(profiles) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(profiles)); } catch (e) {}
}

const SHARED_CUSTOMER_PROFILES = {
  _profiles: load(),   // keyed by Supabase userId or email
  _subs: [],

  get(key) {
    return this._profiles[key] || null;
  },

  getAll() {
    return { ...this._profiles };
  },

  set(key, data) {
    this._profiles[key] = {
      ...(this._profiles[key] || {}),
      ...data,
      updatedAt: new Date().toISOString()
    };
    save(this._profiles);
    this._notify();
  },

  subscribe(fn) {
    this._subs.push(fn);
    return () => { this._subs = this._subs.filter(f => f !== fn); };
  },

  _notify() {
    const profiles = { ...this._profiles };
    this._subs.forEach(fn => { try { fn(profiles); } catch (e) {} });
  }
};

export default SHARED_CUSTOMER_PROFILES;
